import React from 'react'
import { FadeLoader } from 'react-spinners'
import { Grid } from '@mui/material'
import { makeStyles } from '@material-ui/core'
import { appLogo } from '../lib/Constants'

const useStyles = makeStyles(theme => ({
  logo: {
    width: 238
  },
  container: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column!important',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinner: {
    transform: 'scale(0.8)'
  }
}))

export const LoadingSplash = () => {
  const classes = useStyles()
  return (
    <Grid className={classes.container}>
       <img
              alt={'MyWork'}
              className={classes.logo}
              src={appLogo}
            />
      <Grid item xs={12} p={2}>
        <div className={classes.spinner} >
          <FadeLoader
            loading={true}
            height={12}
            width={4}
          />
        </div>
      </Grid>
  </Grid>
  )
}
